import React from "react";
import { useRouter } from "next/router";
import { redirectBackUrl } from "utils/method";
import getCommonStaticProps from "@xt/ssg";
import LayoutXt from "components/Layout/xt";
import LayoutAuth from "components/Layout/Auth";
import ResetPassword from "components/Pages/ResetPassword";
import Seo from "components/Seo";
import useIsDesktop from "@/hooks/useIsDesktop";

export default function PageResetPassword({ locale, tdk, resolvedUrl }) {
  const router = useRouter();
  const { isDesktop, isReady } = useIsDesktop();
  const isSpikexPc = isReady && isDesktop;

  const onAuthError = () => {
    redirectBackUrl(router);
  };

  return (
    <LayoutXt mobileNav="logoLang" isShowFoot={isSpikexPc} useSiteFooter={isSpikexPc}>
      <Seo tdk={tdk} resolvedUrl={resolvedUrl} locale={locale} />
      <LayoutAuth needLogin={false} onAuthError={onAuthError}>
        <ResetPassword />
      </LayoutAuth>
    </LayoutXt>
  );
}

export const getStaticProps = (context) => getCommonStaticProps(context, "/accounts/reset-password", { zE_show: true });
